import { Component, OnInit, OnDestroy, HostListener, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'jhi-user-menu-container',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './user-menu-container.component.html',
  styleUrls: ['./user-menu-container.component.css']
})
export class UserMenuContainerComponent implements OnInit, OnDestroy {
  @Output() collapseNavbar = new EventEmitter<void>();
  
  currentUser: any = null;
  isUserMenuOpen: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-menu-container')) {
      this.isUserMenuOpen = false;
    }
  }

  ngOnInit() {
    // Gọi API me mỗi lần component load
    this.loadCurrentUser();
  }

  ngOnDestroy(): void {
    // Cleanup nếu cần
  }

  loadCurrentUser() {
    this.authService.getCurrentUser().subscribe({
      next: (user) => {
        this.currentUser = user;
      },
      error: (error) => {
        console.error('Failed to load current user:', error);
        this.currentUser = null;
      }
    });
  }

  toggleUserMenu() {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  closeUserMenu() {
    this.isUserMenuOpen = false;
  }

  onCollapseNavbar() {
    this.closeUserMenu();
    this.collapseNavbar.emit();
  }

  logout() {
    this.authService.logout().subscribe();
  }

  hasAdminRole(): boolean {
    if (!this.currentUser) {
      return false;
    }

    // Check roles array
    if (this.currentUser.roles && Array.isArray(this.currentUser.roles)) {
      const hasRole = this.currentUser.roles.some((r: any) => {
        if (typeof r === 'string') {
          return r === 'ROLE_ADMIN' || r.includes('ROLE_ADMIN');
        }
        const roleValue = r?.role || r?.name;
        return roleValue === 'ROLE_ADMIN' || roleValue?.includes('ROLE_ADMIN');
      });
      if (hasRole) return true;
    }

    // Check global_roles array
    if (this.currentUser.global_roles && Array.isArray(this.currentUser.global_roles)) {
      const hasRole = this.currentUser.global_roles.some((r: any) => {
        if (typeof r === 'string') {
          return r === 'ROLE_ADMIN' || r.includes('ROLE_ADMIN');
        }
        const roleValue = r?.role || r?.name;
        return roleValue === 'ROLE_ADMIN' || roleValue?.includes('ROLE_ADMIN');
      });
      if (hasRole) return true;
    }

    // Check localStorage 'role' (array of role strings)
    const roleStr = localStorage.getItem('role');
    if (roleStr) {
      try {
        const roles = JSON.parse(roleStr);
        if (Array.isArray(roles)) {
          if (roles.includes('ROLE_ADMIN')) return true;
        }
      } catch (e) {
        // Ignore parse errors
      }
    }

    // Check localStorage 'jhi-cn_role' (array of role objects with role property)
    const cnRoleStr = localStorage.getItem('jhi-cn_role');
    if (cnRoleStr) {
      try {
        const cnRoles = JSON.parse(cnRoleStr);
        if (Array.isArray(cnRoles)) {
          const hasRole = cnRoles.some((roleObj: any) => {
            const roleName = typeof roleObj === 'string' ? roleObj : roleObj?.role || roleObj?.name;
            return roleName === 'ROLE_ADMIN' || roleName?.includes('ROLE_ADMIN');
          });
          if (hasRole) return true;
        }
      } catch (e) {
        // Ignore parse errors
      }
    }

    return false;
  }
}

